import { getJsonExport, Locale } from '@typescript-kit/core';

import * as texts from '../text/welcome-de.text.json';

export const welcomeDeLocale: Locale = {
  texts: getJsonExport(texts)
};
